import type { ComputedRef } from 'vue'

import type { TenantConfig, TenantFeatureFlagKey, TenantFeatureFlags } from '@/config/app/types'

import { useAppConfig } from './useAppConfig'

/**
 * Значения feature flags по умолчанию.
 * Используются, если тенант явно не задал значение в своей конфигурации.
 * Для уже существующих фич дефолт true сохраняет обратную совместимость:
 * чтобы отключить фичу конкретному тенанту, нужно явно выставить false в его конфиге.
 */
export const FEATURE_FLAG_DEFAULTS: Required<TenantFeatureFlags> = {
  employeeThankButton: true,
  useLatinOnlyAddresses: false,
  canViewColleaguesList: true,
}

/**
 * Возвращает значение feature flag с учётом дефолтов (без composable).
 * Используется в router guards и других non-setup контекстах.
 */
export function resolveFeatureFlag(config: TenantConfig, flag: TenantFeatureFlagKey): boolean {
  return config.featureFlags?.[flag] ?? FEATURE_FLAG_DEFAULTS[flag]
}

/**
 * Composable для проверки feature flag текущего тенанта
 * @param flag - ключ feature flag из TenantFeatureFlags
 * @returns реактивное значение флага с учётом дефолтов
 */
export const useFeatureFlag = (flag: TenantFeatureFlagKey): ComputedRef<boolean> => {
  const appConfig = useAppConfig()
  return computed(() => resolveFeatureFlag(appConfig, flag))
}
